import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import cn from 'classnames';
import styles from '../GlucoseConcentrationLevels.pcss';
const LinkStartLine = ({ gcl, idx, glucoseConcentrationLevels, aggregatedGCL })=>{
    if (aggregatedGCL[idx] && (gcl.name === aggregatedGCL[idx].name || gcl.name === 'target' && glucoseConcentrationLevels[idx + 1].name !== 'tight')) {
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.segment, styles.segment_range, styles.segment_link),
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.link,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.link__startLine
                })
            })
        }, gcl.name);
    }
    if (gcl.name === 'veryHigh' || gcl.name === 'target' || gcl.name === 'low') {
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.segment, styles.segment_range, styles.segment_link),
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.link,
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.link__startLine, styles.link__startLine_joint)
                })
            })
        }, gcl.name);
    }
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.segment, styles.segment_range, styles.segment_link),
        children: /*#__PURE__*/ _jsx("div", {
            className: cn(styles.link, styles['link--uplink']),
            children: /*#__PURE__*/ _jsx("div", {
                className: cn(styles.link__startLine, styles.link__startLine_joint)
            })
        })
    }, gcl.name);
};
export default /*#__PURE__*/ memo(LinkStartLine);
